import en from './en-US';
import fr from './fr-CA';
import de from './de-DE';
import jp from './ja-JP';

export default {
  ...en,
  ...fr,
  ...de,
  ...jp,
};
